import { render, staticRenderFns } from "./RipaTextInput.vue?vue&type=template&id=726a1531"
import script from "./RipaTextInput.vue?vue&type=script&lang=js"
export * from "./RipaTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports